import React from "react"
import PropTypes from "prop-types"
import { Button, Title } from "@bw/bits"
import styled from "styled-components"
import { Link } from "gatsby"
import { breakpoints } from "../../../theme"

const StyledWrapper = styled.div`
  position: relative;
  max-width: 100%;
  display: flex;
  padding: 24px;
  box-shadow: 0px 0px 55px rgba(140, 137, 176, 0.23);
  background-color: var(--page-color);
  overflow: hidden;

  @media (min-width: ${breakpoints.medium}px) {
    padding: 48px;
  }

  @media (min-width: ${breakpoints.large}px) {
    padding: 72px;
  }
`
const Plus = styled.div`
  > svg {
    position: absolute;
    left: -100px;
    bottom: -40px;
    color: #fff;
    opacity: 0.3;
  }
`

const StyledLink = styled(Link)`
  text-decoration: none;
`

const StyledA = styled.a`
  text-decoration: none;
`

const StyledCtA = styled.div`
  color: ${props => (props.textColor === "positive" ? "#000000" : "#ffffff")};
  position: relative;
  z-index: 2;
`

const CallToAction = ({
  suptitle,
  title,
  subtitle,
  buttonLabel,
  to,
  href,
  onClick,
  textColor,
  external = false,
}) => {
  const Cta = ({ onClickEvent }) => (
    <StyledWrapper onClick={onClickEvent}>
      <StyledCtA textColor={textColor}>
        <Title suptitle={suptitle} title={title} subtitle={subtitle} />
        {buttonLabel && <Button label={buttonLabel} primary />}
      </StyledCtA>
      <Plus>
        <svg width="358" height="358">
          <use xlinkHref="#plus" />
        </svg>
      </Plus>
    </StyledWrapper>
  )

  const linkProps = {}

  if (external) {
    linkProps.target = "_blank"
    linkProps.rel = "noreferrer"
    href = to
    to = undefined
  }

  switch (true) {
    case typeof to !== "undefined":
      return (
        <StyledLink to={to}>
          <Cta />
        </StyledLink>
      )

    case typeof href !== "undefined":
      return (
        <StyledA href={href} {...linkProps}>
          <Cta />
        </StyledA>
      )

    case typeof onClick !== "undefined":
      return <Cta onClickEvent={onClick} />

    default:
      return <Cta />
  }
}

CallToAction.propTypes = {
  suptitle: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  buttonLabel: PropTypes.string,
  to: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  textColor: PropTypes.oneOf(["positive", "negative"]),
}

CallToAction.defaultProps = {
  textColor: "positive",
}

export { CallToAction }
